import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  PickedNotInvoicedCriteriaBean,
  PickedNotInvoicedListRequest,
  RestPageListBean,
} from "../ds/ds.js";
import { AddIcon, } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DatePickerComponent_adv,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricModule,
  PopupLogisticOrderModule,
} from "../modules/ModuleUtil.js";
import { ModuleUtils } from "../modules/ModuleUtils";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class InboundOpenOrdersNotReceived extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Inbound OpenOrder NotReceived Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteriaViewShow: false,
      criteria: new PickedNotInvoicedCriteriaBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      success_list: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      inquiryLineDataList: [],
      isShowCustomerModule: false,
      isShowLogisticOrderModule: false,
      isShowFabricStyleModule: false,
      isShowLinePopup: false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    // let criteria = this.state.criteria;
    // // criteria.salesRepresentativeCode = "admin";
    // const currentDay = new Date();
    // const firstDay = new Date(
    //   currentDay.getFullYear(),
    //   currentDay.getMonth(),
    //   1
    // );
    // const lastDay = new Date(
    //   currentDay.getFullYear(),
    //   currentDay.getMonth() + 1,
    //   0
    // );
    // criteria.fromPickedDate = firstDay;
    // criteria.toPickedDate = currentDay;
    // this.setState({ criteria: criteria });
    ModuleUtils.getLogisticOrderStatusList();
    ModuleUtils.getLogisticOrderLineStatusList();
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  onChange = (e) => {
    let temp_criteria = this.state.criteria;
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadInboundOpenOrderInquiryList(criteria);
  };
  loadInboundOpenOrderInquiryList = (criteria) => {
    if (
      SecurityAccessManager.InboundOpenOrderNotReceivedDetailsInquirylsInquiry_IsAccessible()
    ) {
      ReportService.inquireInboundOpenOrdersNotReceivedList(
        criteria,
        this.loadInboundOpenOrderInquiryListPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadInboundOpenOrderInquiryListPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if ((response.data != null) & (response.data.result != null)) {
      let resultList = [];
      if (!isEmptyArray(response.data.result.infoList)) {
        resultList = response.data.result.infoList;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: resultList,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new PickedNotInvoicedListRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.InboundOpenOrderNotReceivedDetailsInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateInboundOpenOrdersNotReceivedListReport(
          listRequest,
          this.generateReportPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.InboundOpenOrderNotReceivedDetailsInquiryInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateInboundOpenOrdersNotReceivedListReport(
          listRequest,
          this.generateReportPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateReportPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        if (!isEmptyString(reportFilePath)) {
          window.open(this.report_url + reportFilePath);
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new PickedNotInvoicedCriteriaBean();
    criteria.companyCode = this.companyCode;
    // criteria.salesRepresentativeCode = "admin";
    // const currentDay = new Date();
    // const firstDay = new Date(
    //   currentDay.getFullYear(),
    //   currentDay.getMonth(),
    //   1
    // );
    // const lastDay = new Date(
    //   currentDay.getFullYear(),
    //   currentDay.getMonth() + 1,
    //   0
    // );
    // criteria.fromPickedDate = firstDay;
    // criteria.toPickedDate = currentDay;
    this.setState({
      criteria: criteria,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new PickedNotInvoicedCriteriaBean();
    criteria.companyCode = this.companyCode;
    // criteria.salesRepresentativeCode = "admin";
    // const currentDay = new Date();
    // const firstDay = new Date(
    //   currentDay.getFullYear(),
    //   currentDay.getMonth(),
    //   1
    // );
    // const lastDay = new Date(
    //   currentDay.getFullYear(),
    //   currentDay.getMonth() + 1,
    //   0
    // );
    // criteria.fromPickedDate = firstDay;
    // criteria.toPickedDate = currentDay;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  lineDetail = (e, val, data) => {
    if (e.detail === 1) {
      let inquiryLineDataList = new Array();
      if (!isEmptyArray(data.itemInfos)) {
        inquiryLineDataList = data.itemInfos;
      }
      this.setState({
        inquiryLineDataList: inquiryLineDataList,
        isShowLinePopup: true,
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowLogisticOrderModule: isOpen,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewLogisticOrderModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowLogisticOrderModule: true,
          moduleForPopup: (
            <PopupLogisticOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLinePopup: false,
    });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", <AddIcon />, false)
        .setStyleDetails("center", "", "", "wt-2", "wt-2")
        .setClickDetails(true, true, this.lineDetail, <AddIcon />)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Customer#",
          "customerCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InBoundOrder#", "logisticOrderNumber", true)

        .setStyleDetails("left", "", "", "wt-3", "wt-3")

        .setClickDetails(true, false, this.viewLogisticOrderModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate", "orderDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CSR", "salesRepresentativeCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setStatusDetails(true, this.getCaption)
    );
    return columns;
  };

  getCaption = (status) => {
    return ModuleUtils.getLogisticOrderStatusCaption(status);
  };
  inquiryLineDataColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("InBoundOrder#", "logisticOrderNumber", true)

        .setStyleDetails("left", "", "", "wt-3", "wt-3")

        .setClickDetails(true, false, this.viewLogisticOrderModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Line#", "lineNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Item Name" : "FabricStyle Name", "fabricStyleName", true)
        .setStyleDetails("left", "8", "", "wt-4", "wt-4")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Open Qty", "openQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AdjustQty", "adjustedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "lineStatus", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-3")
        .setStatusDetails(true, this.getLinestatusCaption)
    );

    return columns;
  };
  getLinestatusCaption = (status) => {
    return ModuleUtils.getLogisticOrderLineStatusCaption(status);
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryLineDataList = this.state.inquiryLineDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          criteria={this.state.criteria}
          onChange={this.onChange}
        />
        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
            />
         </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowLogisticOrderModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel0"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowCustomerModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel1"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>

        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLinePopup}
          closeOnEsc={false}
          title={"Line Details"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          closeOnDocumentClick={false}
          popupLvlClass={"popupSizeLevel0"}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <CustomTable
              data={inquiryLineDataList}
              columns={this.inquiryLineDataColumns()}
            />
          }
        />
      </div>
    );
  }
}
class CriteriaView extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      criteria: this.props.criteria,
    };
    // this.salesRepresentativeCodeRef = React.createRef();
  }
  componentDidMount() {
    // this.setInputFocus();
  }
  // setInputFocus() {
  //   if (this.salesRepresentativeCodeRef.current != null) {
  //     this.salesRepresentativeCodeRef.current.focus();
  //   }
  // }
  onChange = (e) => {
    this.props.onChange(e);
  };
  render() {
    let criteria = this.props.criteria;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row className="d-flex justify-content-left">
          {/* <Col sm="1">
            {" "}
            <FormLabel>CSR</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={this.salesRepresentativeCodeRef}
              name="salesRepresentativeCode"
              onChange={this.onChange}
              value={criteria.salesRepresentativeCode}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col> */}
          <Col sm="1">
            {" "}
            <FormLabel>From Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="fromPickedDate"
              onChange={this.onChange}
              value={criteria.fromPickedDate}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>To Date</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="toPickedDate"
              onChange={this.onChange}
              value={criteria.toPickedDate}
              disabled={isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

function InboundOpenOrdersNotReceivedInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <InboundOpenOrdersNotReceived {...props} name="" /> <br />
    </div>
  );
}

export default InboundOpenOrdersNotReceivedInquiry;
